export const TEMPLATES = {
  menu: 1,
  referenceData: 2,
  referenceDataList: 3,
  user: 4,
  userList: 5,
  organisation: 6,
  organisationList: 7,
  personDetail: 8,
  personList: 9,
  reportList: 10,
  careAllowancePlacementAdjustmentList: 11,
  errorLogList: 15,
  concessionsApplicationNonMainsWater: 16,
  careAllowanceApplicationList: 17,
  jobSchedule: 18,
  careAllowancePlacementAdjustment: 19,
  concessionsApplicationNonMainsEnergy: 20,
  concessionsApplicationnonMainsLifeSupport: 21,
  concessionsApplicationnonMainsMedicalCooling: 22,
  concessionsApplicationedaAndPowGoldCardMunicipalRates: 23,
  vmgEmailTemplate: 25,
  applicationDetailCreateUpdateCarer: 26,
  vendorList: 27,
  vendor: 28,
  careAllowanceYearList: 29,
  careAllowanceYear: 30,
  careAllowanceRateList: 31,
  careAllowanceRate: 32,
  concessionsApplicationList: 33,
  concessionsApplicationDetails: 34,
  applicationDetailCreateUpdatePlacement: 35,
  concessionsApplicationReadyForApprovalList: 36,
  careAllowancePlacementRuleList: 37,
  careAllowancePlacementRule: 38,
  careAllowanceInvoicePeriod: 39,
  concessionsApplicationRebateCalculationRuleList: 40,
  concessionsRebateCalculationRule: 41,
  careAllowancePlacement: 42,
  settingList: 43,
  setting: 44,
  careAllowancePlacementBulkAdHocInvoiceQuery: 46,
  glStringLookupMappingSetList: 47,
  glStringLookupMapping: 48,
  glStringMappingList: 49,
  glStringMapping: 50,
  glStringLookupMappingSet: 51,
  jobScheduleList: 52,
  monitorInvoiceExportList: 53,
  monitorInvoiceExport: 54,
  concessionsInvoiceList: 55,
  concessionsApplicationBulkUploadErrorLogList: 56,
  bankDetail: 57,
  concessionsApplicationBulkUpload: 58,
  concessionsApplicationBulkUploadList: 59,
  careAllowancePerson: 60,
  agencyList: 61,
  agency: 62,
  jobRunLogList: 63,
  concessionsApplicationBulkUploadDetail: 64,
  iccmsRequestProcessingScheduleList: 65,
  iccmsRequestProcessingSchedule: 66,
  careAllowancePlacementBulkAdHocInvoiceQueryList: 67,
  careAllowancePlacementInvoiceList: 68,
  careAllowancePlacementList: 69,
  careAllowanceLocalAdoption: 70,
  victorianPatientTransportAssistanceSchemeApplication: 72,
  vptasApplicationList: 73,
  victorianPatientTransportAssistanceSchemeApplicationRebateCalculationRateList: 74,
  victorianPatientTransportAssistanceSchemeRebateCalculationRule: 75,
  victorianPatientTransportAssistanceSchemeNominatedPatientDetails: 78,
  vptasApplicationDetails: 79, // VPTAS Application Details (Staff Portal) 
  victorianPatientTransportAssistanceSchemeApplicationSubsidyList: 80,
  victorianPatientTransportAssistanceSchemeApplicationTripList: 81,
  vptasInvoiceList: 82,
  vptasSpecialistList: 83,
  vptasSpecialist: 84,
  vptasLgaList: 85,
  vptasSpecialistProviderInformation: 86,
  vptasLga: 87,
  vptasAdjustmentApplication: 88,
  vptasSubsidy: 89,
}

export const VERSIONS = {
  default: 0,
  latest: 0
}

export const TEMPLATE_NAMES = {
  homepage: 'homepage',
  menu: 'menu',
  referenceData: 'referenceData'
}
